import { featureConstant, featureFlag } from '@/constants/configuration/feature.js';

export const feature = (featureName) => {
	const currentEnv = process.env.REACT_APP_CDI_ENV || 'prod';
	return featureFlag[featureName]?.[currentEnv] ?? false;
}

export const featureV2 = (featureName, features) => {
	return features?.includes(featureName)
}

export const features = featureConstant;
